export const apiVersion =
    process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-04-22'

export const previewUrl =
    process.env.NODE_ENV === 'development'
        ? (process.env.NEXTAUTH_URL || process.env.SANITY_STUDIO_PREVIEW_URL || 'http://localhost:3000')
        : (process.env.SANITY_STUDIO_PREVIEW_URL || 'https://gruppopiccirillo.it/')

export const dataset = assertValue(
    process.env.NEXT_PUBLIC_SANITY_DATASET,
    'Missing environment variable: NEXT_PUBLIC_SANITY_DATASET'
)

export const projectId = assertValue(
    process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    'Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID'
)

export const useCdn = process.env.NEXT_PUBLIC_SANITY_USE_CDN === 'true'

function assertValue<T>(v: T | undefined, errorMessage: string): T {
    if (v === undefined) {
        throw new Error(errorMessage)
    }

    return v
}
